module.exports = __webpack_public_path__ + "eda003ea2cc1ea73.svg";